import React from 'react';
import {Nav} from "react-bootstrap";
import {Link} from "react-router-dom";

function TabItem(props) {
    return (<Nav.Item>
        <Link to={props.href ?? '#'} className="tab-link" >
            {props.icon}
            <span>
                {props.children}
            </span>
            <h6 className="text-white" style={{fontSize:"12px"}}>{props.title}</h6>
        </Link>
    </Nav.Item>);
}

export default TabItem;
